import SEO from "@/components/base/SEO";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import FeaturedArticles from "./components/FeaturedArticles";
import StatsSection from "./components/StatsSection";
import CTASection from "./components/CTASection";
import FAQSection from "./components/FAQSection";

export default function Home() {
  const seoData = {
    title: "首页",
    description:
      "福利导航为您汇聚全网优质福利资源，包括电商优惠、会员权益、生活补贴、政府福利等，帮助用户快速找到最实用的福利入口，省时省钱，轻松享受各类专属权益。",
    keywords:
      "福利导航,福利导航网站,在线福利导航,生活福利大全,优惠福利汇总,会员福利入口,免费福利资源导航",
    canonicalUrl: "https://jobbang.cn",
    ogType: "website",
    schema: {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "福利导航",
      url: "https://jobbang.cn",
      description:
        "一站式福利资源聚合平台，汇聚全网优质福利资源，覆盖电商优惠、会员权益、生活补贴、政府福利等八大品类。",
      potentialAction: {
        "@type": "SearchAction",
        target: "https://jobbang.cn/search?q={search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
  };

  return (
    <>
      <SEO data={seoData} />
      <main>
        <HeroSection />
        <StatsSection />
        <CategoryGrid />
        <FeaturedArticles />
        <CTASection />
        <FAQSection />
      </main>
    </>
  );
}